var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0H24C25.1935 0 26.3381 0.474106 27.182 1.31802C28.0259 2.16193 28.5 3.30653 28.5 4.5V18C28.5 19.1935 28.0259 20.3381 27.182 21.182C26.3381 22.0259 25.1935 22.5 24 22.5H4.5C3.30653 22.5 2.16193 22.0259 1.31802 21.182C0.474106 20.3381 0 19.1935 0 18V4.5C0 3.30653 0.474106 2.16193 1.31802 1.31802C2.16193 0.474106 3.30653 0 4.5 0ZM4.5 1.5C3.75 1.5 3.09 1.755 2.58 2.205L14.25 9.75L25.92 2.205C25.41 1.755 24.75 1.5 24 1.5H4.5ZM14.25 11.565L1.695 3.42C1.575 3.75 1.5 4.125 1.5 4.5V18C1.5 18.7956 1.81607 19.5587 2.37868 20.1213C2.94129 20.6839 3.70435 21 4.5 21H24C24.7956 21 25.5587 20.6839 26.1213 20.1213C26.6839 19.5587 27 18.7956 27 18V4.5C27 4.125 26.925 3.75 26.805 3.42L14.25 11.565Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c3ad1f380eb401bfb4582f808e7c256a.svg";
export { ForwardRef as ReactComponent };